export default {
  methods: {
    loadedComponents (name) {
      this.loadingComponents[name] = false;
    },
    pcImg (path) {
      let domain = window.location.protocol + '//' + window.location.host;
      return domain + '/assets/pc/img/' + path.replace('/^\//', '');
    },
    spImg (path) {
      let domain = window.location.protocol + '//' + window.location.host;
      return domain + '/assets/sp/img/' + path.replace('/^\//', '');
    },
    commonImg (path) {
      let domain = window.location.protocol + '//' + window.location.host;
      return domain + '/assets/common/img/' + path.replace('/^\//', '');
    },
  }
}